export const userActionDataAttributeParsed = 'faroUserActionName';
export const userActionDataAttribute = 'data-faro-user-action-name';

export {
  MESSAGE_TYPE_DOM_MUTATION,
  MESSAGE_TYPE_HTTP_REQUEST_START,
  MESSAGE_TYPE_HTTP_REQUEST_END,
} from '../_internal/monitors/const';



// WEBPACK FOOTER //
// ../../../../src/instrumentations/userActions/const.ts